import { UnidadeService } from './../../../services/http/unidade.service';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-list-unidades-atendidas',
  templateUrl: './list-unidades-atendidas.component.html',
  styleUrls: ['./list-unidades-atendidas.component.scss']
})
export class ListUnidadesAtendidasComponent implements OnInit {

  listaUnidades: any;
  listaUnidadesAtendidas: any;
  pontosAtendidos: any;
  unidadesAtendidas: any;

  form = {
    pontoAtendimento: new FormControl(''),
    unidade: new FormControl('')
  }

  order = {
    pontoAtendimento: '',
    documento: '',
    telefone: ''
  }

  first: number = 0;
  unidade: any = {};
  dynamicdownloadName: string = "Unidades Atendidas"

  cols: any = [
    { field: 'nomeUnidadeAtendida', header: 'Unidade Atendida' },
    { field: 'documentoUnidadeAtendida', header: 'Documento' },
    { field: 'telefoneUnidadeAtendida', header: 'Telefone' }
  ];

  constructor(private loginService: LoginService, private unidadeService: UnidadeService, private modalService: ModalMsgService, private router: Router) { }

  ngOnInit() {
    this.unidadeService.getListaUnidadeNomeFantasia().then(u => { 
      this.listaUnidades = u;
      this.listaUnidadesAtendidas = u;
      this.loginService.getLogIn().pipe(first()).subscribe(u => {
        this.listaUnidades.splice(0, 0, u.unidade);
      });
    });
    this.form.pontoAtendimento.valueChanges.pipe(distinctUntilChanged(), debounceTime(300)).subscribe(c => {
      this.selectUnidade(c)
    });
  }

  selectUnidade(params) {
    if(params && params != '') {
      let id = parseInt(params);
      this.getUnidadesAtendidas(id);
    }
  }

  getUnidadesAtendidas(id) {
    this.unidadeService.getUnidadesAtendidas(id).subscribe(p => {
      this.pontosAtendidos = p
    });
  }

  addUnidade() {
    if(this.form.pontoAtendimento.value) { 
      let params = {
        "pontoAtendimento": parseInt(this.form.pontoAtendimento.value),
        "unidadeAtendida": parseInt(this.form.unidade.value),
      }
      this.unidadeService.addUnidadeAtendida(params).then( () => {
        this.modalService.openDialog(
          'Ponto de atendimento',
          'Unidade cadastrada com sucesso!',
          'success',
          false
        ).finally( () => {
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => this.router.navigate(['unidade', 'unidades-atendidas']));
        });

      }).catch( () => {
        this.modalService.openDialog(
          'Ponto de atendimento',
          'Erro ao adicionar unidade. Tente novamente!',
          'danger',
          false
        );
      });
    }
  }

  delUnidade(id) {
    if(id) {
      let params = {id: id}
      this.modalService.justificativa('Remover unidade atendida').then(justificativa => {
        if(justificativa) {
          this.unidadeService.delUnidadeAtendida(params, justificativa).then( () => {
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => this.router.navigate(['unidade', 'unidades-atendidas']));
          });
        }else{
          this.modalService.openDialog('Erro ao remover unidade atendida',
          'Informe uma Justificativa para concluir a operação', 'danger');
        }
      });
    }
  }

  setOrder(){}

}
